package com.essntl.features.client.ui.addeditclient

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class AddEditClientValidation {
    val addEditClientForm = AddEditClientForm()
}

class AddEditClientForm : Form() {
    val lastName = StringField(NonEmptyValidator)

    override val fields: List<Field>
        get() = listOf(lastName)
}